module.exports = __webpack_public_path__ + "img/baoshang02.ba3408f1.png";